import { useMountEffect } from "primereact/hooks";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { learningProgramsRequest } from "../../../../store/slices/selfSlice";
import { LearningBannerWidget, LearningProgramWidget } from "../../widgets";
import PreviewCertificate from "../../certificates/preview";
import LearningJourneyCards from "./LearningJourneyCards";
import "./learning-journey.scss";
import { SelectButton } from "primereact/selectbutton";
import { MultiSelect } from "primereact/multiselect";
import { getProgramStatus } from "../../../../helpers/LearningStatus";

const LearningJourney = ({
  learningProgramsRequest,
  learningPrograms,
  enterprise,
}) => {
  const intl = useIntl();

  const [showPreview, setShowPreview] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const { learnerSettings = {} } = enterprise?.learningConfiguration || {};
  const { showLearningBanner, showLearningStats, customLabels } =
    learnerSettings;

  useMountEffect(() => {
    learningProgramsRequest();
  });

  // A missing end date (no due date, or Optional training) is never overdue.
  const getStatusProps = (program) => getProgramStatus(program);

  const [activeTab, setActiveTab] = useState("cards");

  const optionTemplate = (option) => {
    return <i className={option.icon}></i>;
  };

  return (
    <div className="edexlms-full-wrap-height">
      {(showLearningBanner && (
        <LearningBannerWidget showLearningStats={showLearningStats} />
      )) ||
        null}
      <div className="edexlms-page-content">
        <div className="edexlms-page-header flex-column md:flex-row gap-2">
          <div className="edexlms-page-title" style={{ alignSelf: "start" }}>
            {customLabels?.learningJourney ||
              intl.formatMessage({
                id: "learning_journey",
              })}
          </div>
          <div className="edexlms-page-actions flex gap-2">
            <>
              <MultiSelect
                value={selectedFilters}
                onChange={(e) => setSelectedFilters(e.value)}
                optionLabel="name"
                data-testid="journey-status"
                placeholder={intl.formatMessage({ id: "filter_by_status" })}
                options={[
                  {
                    id: "completed",
                    name: intl.formatMessage({ id: "completed" }),
                  },
                  {
                    id: "inprogress",
                    name: intl.formatMessage({ id: "inprogress" }),
                  },
                  {
                    id: "overdue",
                    name: intl.formatMessage({ id: "overdue" }),
                  },
                  {
                    id: "notstarted",
                    name: intl.formatMessage({ id: "not_started" }),
                  },
                ]}
              />
              <SelectButton
                value={activeTab}
                itemTemplate={optionTemplate}
                optionLabel="value"
                onChange={(e) => setActiveTab(e.value)}
                options={[
                  { icon: "pi pi-th-large", value: "cards" },
                  { icon: "pi pi-list", value: "list" },
                ]}
              />
            </>
          </div>
        </div>
        <div
          className={`edexlms-page-body dashboard ${
            showLearningBanner ? "with-banner" : "without-banner"
          }`}
        >
          {(activeTab === "cards" && (
            <LearningJourneyCards
              filters={{
                status: selectedFilters.map((f) => f.id),
              }}
              learningPrograms={learningPrograms}
              getStatusProps={getStatusProps}
              setSelectedCertificate={setSelectedCertificate}
              setShowPreview={setShowPreview}
            />
          )) || (
            <LearningProgramWidget
              getStatusProps={getStatusProps}
              filters={{
                status: selectedFilters.map((f) => f.id),
              }}
              style={{ minHeight: "97%" }}
            />
          )}
        </div>
      </div>
      <Dialog
        header={intl.formatMessage({ id: "preview_certificate" })}
        visible={showPreview}
        style={{
          height: "700px",
          width: "600px",
          minHeight: "700px",
          minWidth: "600px",
        }}
        onHide={() => setShowPreview(false)}
      >
        <PreviewCertificate
          url={selectedCertificate?.url}
          orientation={selectedCertificate?.orientation}
          isActual={true}
          learningName={selectedCertificate?.learningName}
          dateofCompletion={selectedCertificate?.dateofCompletion}
        />
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  learningPrograms: state.self?.learningPrograms || [],
  enterprise: state?.global?.enterprise,
});

const mapDispatchToProps = (dispatch) => ({
  learningProgramsRequest: () => dispatch(learningProgramsRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LearningJourney);
